import { User } from "./types/User";
import getUserInfo from "./requests/getUserInfo";
import { CardType } from "./types/LibraryCard";
import { format, isSameYear, isSameMonth, isValid, parseISO } from "date-fns";
import { ru } from 'date-fns/locale';

export const API_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://api.readed.me';
export const TABLET_MAX_WIDTH = 820;
export const MOBILE_MAX_WIDTH = 600;

export const MARK_LABELS = [
	"Самое худшее, что я читал(а)",
	"Очень плохо",
	"Плохо",
	"Посредственно",
	"Удовлетворительно",
	"Средне",
	"Выше среднего",
	"Хорошо",
	"Очень хорошо",
	"Отлично",
];

let userProfile: User;

const getUserProfileRequest = async () => {
	if (!!localStorage.getItem('session_token')) {
		const profile = await getUserInfo();

		userProfile = profile;

		localStorage.setItem('userProfile', JSON.stringify(userProfile));
	}
}

export const useProfile = async () => {
	if (!userProfile) {
		await getUserProfileRequest();
	}

	return userProfile;
};

export const getReadableCardType = (cardType: CardType) => {
	switch (cardType) {
		case CardType.AlreadyRead:
			return 'Прочитано';
		
		case CardType.ReadNow:
			return 'Читаю';
		
		case CardType.WantRead:
			return 'Хочу прочитать';
	}
}


export const getDatePeriod = (startRead: Date | string, finishRead?: Date | string, begin: string = '', to: string = ' - ', hideDay?: boolean): string => {
	const _startRead = startRead instanceof Date ? startRead : parseISO(startRead as string);
	const _finishRead = finishRead instanceof Date || !finishRead ? finishRead as Date : parseISO(finishRead as string);

	const startFormat = hideDay ? 'MMMM' : 'd MMMM';

	if (!isValid(_startRead)) {
		return null;
	}

	if (!_finishRead) {
		return `с ${localedFormat(
			_startRead,
			`${startFormat}${isSameYear(_startRead, new Date()) ? "" : " yyyy"}`
		)}`;
	}

	if (isSameYear(_startRead, _finishRead)) {
		if (isSameMonth(_startRead, _finishRead)) {
			return `${begin}${localedFormat(_startRead, 'd')} ${to} ${localedFormat(_finishRead, startFormat)}`;
		}

		return `${begin}${localedFormat(_startRead, startFormat)} ${to} ${localedFormat(_finishRead, startFormat)}`;
	}

	return `${begin}${localedFormat(_startRead, `${startFormat}, yyyy`)} ${to} ${localedFormat(_finishRead, `${startFormat}, yyyy`)}`
};

export const localedFormat = (date: Date, formatStr: string): string => {
	if (!isValid(date)) {
		return;
	}

	return format(date, formatStr, {
		locale: ru
	});
};
